import type { OnDemandService } from './ServiceTypeToggle';

/**
 * Labels de `button_click` do sob demanda no fluxo novo (musa-agreements).
 *
 * Coleta reaproveita os nomes do fluxo antigo (`sobdemanda_coletas_*`) para não quebrar as séries
 * do GA4; movimentação de equipamento tem prefixo próprio, para a série de coleta continuar só de
 * coleta. Ver catálogo em docs/GA4_ANALYTICS_ARCHITECTURE.md.
 */
export type OnDemandAnalyticsAction =
  | 'form_next_step'
  | 'voltar_formulario'
  | 'criar_solicitacao_sucesso'
  | 'criar_solicitacao_parcial'
  | 'anexar_foto';

const PREFIX: Record<OnDemandService, string> = {
  collect: 'sobdemanda_coletas',
  bucket: 'sobdemanda_cacamba',
};

export const onDemandButtonLabel = (service: OnDemandService, action: OnDemandAnalyticsAction): string =>
  `${PREFIX[service]}_${action}`;

/** Valor do parâmetro `servico` em `sobdemanda_trocar_servico` — o serviço escolhido. */
export const ON_DEMAND_SERVICE_PARAM: Record<OnDemandService, string> = {
  collect: 'coleta',
  bucket: 'cacamba',
};
